import { rem } from '@visiba/std';
import { FlexibleSpacerModel } from '@services/flexible_component/mod';
import { Spacer } from '@visiba-cortex/react-ui-std';

interface Props {
	component: FlexibleSpacerModel;
}

const spacerValueMap = new Map<string, string>([
	['XSmall', rem(8)],
	['Small', rem(16)],
	['Medium', rem(32)],
	['Large', rem(64)],
	['XLarge', rem(128)],
]);

export function FlexibleSpacer({ component }: Props): JSX.Element {
	return (
		<Spacer
			data-testid='FlexibleSpacer'
			height={spacerValueMap.get(component.vertical)}
			width={spacerValueMap.get(component.horizontal)}
		></Spacer>
	);
}
